import { axios } from "../utils/axios";

// Who may use the MNB Rates Android app, and which nurseries it offers.
const base = `${process.env.REACT_APP_API_HOST}/api/field-rates`;
const data = async (p) => (await p).data;

export const listFieldEntries = (params) => data(axios.get(`${base}/admin/entries`, { params }));
export const reviewCompetitorEntry = (id, status) => axios.post(`${base}/admin/entries/${id}/review`, { status });
export const setAppNurseryKind = (id, kind) => axios.patch(`${base}/nurseries/${id}`, { kind });
export const getPlantCatalogue = () => data(axios.get(`${base}/catalogue`));
export const listAppUsers = () => data(axios.get(`${base}/users`));
export const addAppStaff = (body) => axios.post(`${base}/users`, body);
export const setAppUserStatus = (id, status) => axios.patch(`${base}/users/${id}`, { status });
export const listAppNurseries = () => data(axios.get(`${base}/nurseries`));
export const addAppNursery = (zohoVendorId) => axios.post(`${base}/nurseries`, { zohoVendorId });
export const removeAppNursery = (id) => axios.delete(`${base}/nurseries/${id}`);
